<template>
	<div style="margin:0 auto;width:100%;" class="points-show">
		<div class="hearder">
			<div class="logo-div">
				<img src="../../../public/img/icons/logo.png" />
			</div>
			<bread-menu />
			<el-popover placement="bottom" width="100" trigger="click"
				style="position: absolute;right:40px; top:50%;transform:translateY(-50%)">
				<el-link size="mini" style="margin: 0 auto" @click="toindex">
					首页
				</el-link><br>
				<el-link size="mini" style="margin:10px auto" @click="escLogin">
					退出登录
				</el-link>
				<el-button slot="reference" icon="el-icon-s-grid" size="small" plain circle />
			</el-popover>
		</div>
	</div>
</template>
<script>
	import BreadMenu from '../../components/BreadMenu/index.vue';
	export default {
		components: {
			BreadMenu
		},
		data() {
			return {};
		},
		methods: {
			escLogin() {
				this.$confirm('是否退出登录', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.replace('/login');
					window.localStorage.removeItem('token');
					this.$message({
						type: 'success',
						message: '已退出'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			toindex() {
				this.$router.push('/');
			}
		}
	};
</script>
<style scoped>
	.logo-div {
		width: 180px;
		height: 100%;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.logo-div img {
		width: 180px;
		height: 180px;
		margin-top: 10px;
	}

	.hearder {
		border-bottom: 1px solid rgb(235, 238, 245);
		height: 60px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
</style>
